import React, { MouseEvent } from 'react';
import key from 'weak-key';

import FileEntry from './file-entry';
import Share from '../share';

import { getTranslation } from '../../utils/config';
import type { IItem } from '../../types';

type CardViewProps = {
  id: number;
  expanded: boolean;
  loginRequired: boolean;
  cardData: Array<IItem | undefined>;
  handleDownload: (e: MouseEvent<HTMLAnchorElement>) => void;
  slicedGroupAttributes: Array<{ facetname: string; displayname: string }>;
  toggleExpanded: () => void;
  showMoreButton: boolean;
};

export default function CardView({
  id,
  expanded,
  loginRequired,
  cardData,
  handleDownload,
  slicedGroupAttributes,
  toggleExpanded,
  showMoreButton,
}: CardViewProps): React.ReactElement {
  return (
    <>
      {!!cardData.length && (
        <div className="df-list-module__table-wrapper">
          <table className="df-list-module__table">
            <thead>
              <tr>
                {slicedGroupAttributes?.map((attribute) => (
                  <th key={attribute.displayname} className="df-list-module__table-lang-column">
                    {attribute.displayname}
                  </th>
                ))}
                <th> </th>
                <th> </th>
              </tr>
            </thead>
            <tbody>
              {cardData
                .slice(0, 3)
                .map((file) =>
                  file ? (
                    <FileEntry
                      key={key(file)}
                      attributes={slicedGroupAttributes}
                      loginRequired={loginRequired}
                      handleDownload={handleDownload}
                      groupId={id}
                      {...file}
                    />
                  ) : (
                    <></>
                  ),
                )}
            </tbody>
          </table>
        </div>
      )}
      <div className="df-list-module__group-actions-wrapper">
        <button
          type="button"
          className={`df-list-module__toggle ${
            showMoreButton ? '' : 'df-list-module__toggle--hidden'
          }`}
          onClick={toggleExpanded}
        >
          {getTranslation(expanded ? 'less_info' : 'more_info')}
        </button>
        <Share group={id} type="group" />
      </div>
    </>
  );
}
